export default __webpack_public_path__ + "static/media/home.15c9947e.svg";